import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { CalendarCheck, CalendarX2, Loader2, ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CalendarLinkPage = () => {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');

  const connected = params.get('connected') === '1';
  const failure = params.get('error');

  useEffect(() => {
    if (window.hideAppSplash) window.hideAppSplash();
    document.title = 'Collega il tuo Google Calendar';
    axios.get(`${API}/public/calendar-invite/${token}`)
      .then(res => setInfo(res.data))
      .catch(e => setError(e.response?.data?.detail || 'Link non valido o scaduto'));
  }, [token]);

  const start = () => { window.location.href = `${API}/staff-calendar/auth/start?token=${token}`; };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-5 py-12" data-testid="calendar-link-page">
      <div className="w-full max-w-md rounded-2xl border bg-card p-7 shadow-sm">
        {error ? (
          <div className="text-center" data-testid="calendar-link-error">
            <CalendarX2 className="mx-auto h-10 w-10 text-destructive" />
            <h1 className="mt-4 text-xl font-semibold tracking-tight">Link non più valido</h1>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              {error}. Chiedi al salone di generarne uno nuovo.
            </p>
          </div>
        ) : !info ? (
          <div className="flex items-center justify-center py-10" data-testid="calendar-link-loading">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </div>
        ) : connected || info.already_connected ? (
          <div className="text-center" data-testid="calendar-link-success">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-500/15">
              <CalendarCheck className="h-6 w-6 text-emerald-600 dark:text-emerald-400" />
            </span>
            <h1 className="mt-4 text-xl font-semibold tracking-tight">Calendario collegato</h1>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              {info.google_email ? `${info.google_email} è collegato.` : 'Tutto fatto.'} Gli appuntamenti
              del salone compariranno sul tuo Google Calendar e i tuoi impegni personali terranno occupate
              quelle ore in agenda. Puoi chiudere questa pagina.
            </p>
          </div>
        ) : (
          <div data-testid="calendar-link-start">
            <h1 className="text-2xl font-semibold tracking-tight">
              Ciao {info.staff_name || ''}
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              {info.salon_name || 'Il salone'} ti chiede di collegare il tuo Google Calendar.
              Serve a due cose: i tuoi appuntamenti ti arrivano sul telefono, e i tuoi impegni personali
              tengono occupate quelle ore, così non ti prenotano sopra.
            </p>
            <div className="mt-5 space-y-2 rounded-xl border bg-muted/30 p-4 text-xs leading-relaxed text-muted-foreground">
              <p className="flex items-start gap-2">
                <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                Del tuo calendario leggiamo solo quando sei occupato, mai il contenuto degli eventi privati.
                Puoi togliere l’autorizzazione quando vuoi dal tuo account Google.
              </p>
            </div>
            {failure && (
              <p className="mt-4 rounded-lg border border-destructive/40 bg-destructive/10 px-3 py-2 text-xs text-destructive" data-testid="calendar-link-failure">
                Il collegamento non è andato a buon fine. Riprova.
              </p>
            )}
            <Button className="mt-6 w-full" size="lg" onClick={start} data-testid="calendar-link-authorize">
              Collega con Google
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarLinkPage;
